// extracted by mini-css-extract-plugin
export var container = "_5e-0";
export var error = "_5e-9";
export var label = "_5e-5";
export var light = "_5e-6";
export var md = "_5e-3";
export var sm = "_5e-2";
export var thin = "_5e-8";
export var thinBold = "_5e-7";
export var vertical = "_5e-4";
export var xs = "_5e-1";